import type { MessageAndFormat } from '../shared/chatbot.types';
import { markdownToHtml } from '../shared/chatbot.utils';

interface MessageContentProps {
  message: MessageAndFormat;
  className?: string;
}

// Render a message content based on its format. For Markdown, it is converted to HTML.
export const MessageContent = ({ message, className }: MessageContentProps) => {
  if (message.format === 'html') {
    /** biome-ignore lint/security/noDangerouslySetInnerHtml: data is sent by SG Bot. */
    return <div dangerouslySetInnerHTML={{ __html: message.content }} className={className} />;
  }
  if (message.format === 'markdown') {
    // Convert MD to HTML and sanitize
    const html = markdownToHtml(message.content);
    /** biome-ignore lint/security/noDangerouslySetInnerHtml: data is sent by SG Bot. */
    return <div dangerouslySetInnerHTML={{ __html: html }} className={className} />;
  }
  return <div className={className}>{message.content}</div>;
};
